import { useState, useEffect } from 'react';

export default function useDesktop() {
  const [v, setV] = useState(() => window.innerWidth >= 1024);
  useEffect(() => {
    const h = () => setV(window.innerWidth >= 1024);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return v;
}
